(function($) {$(document).ready(function() {

	$('.tabbed__m-label').on('click', showTabMobile);
	$('.tabbed__d-label').on('click', showTabDesktop);

	// Which one to show on page load
	$('.tabbed__block.open-on-load')
		.addClass('open')
		.find('.tabbed__content')
		.css('display', 'block');
	$('.tabbed__d-label')
		.eq($('.tabbed__block.open-on-load').index())
		.addClass('open');

	function showTabMobile() {
		const $this = $(this);
		
		// Toggle clicked
		$this
			.closest('.tabbed__block')
			.toggleClass('open')
			.find('.tabbed__content')
			.slideToggle();
		
		// Close others
		$this
			.closest('.tabbed__block')
			.siblings('.tabbed__block')
			.removeClass('open')
			.find('.tabbed__content')
			.slideUp();
	}

	function showTabDesktop() {
		const $this = $(this);
		const index = $this.index();

		// Tabs
		$this
			.addClass('open')
			.siblings('')
			.removeClass('open');

		// Content
		$('.tabbed__block')
			.removeClass('open')
			.find('.tabbed__content')
			.hide();
		$('.tabbed__block')
			.eq(index)
			.addClass('open')
			.find('.tabbed__content')
			.show();
	}

});;jQueryBridget("flickity", Flickity, $);})(window.NEW_jquery);